import React, { ReactNode, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "../../lib/utils";
import ScrollUpNoPadding from "../../assets/ScrollUpNoPadding.png";

interface AccordionProps {
  children: ReactNode;
  trigger: ReactNode;
  initialOpen?: boolean;
}

const Accordion = ({
  trigger,
  children,
  initialOpen = false,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  return (
    <div>
      <div className="flex flex-col gap-2">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div>{trigger}</div>
          <img
            src={ScrollUpNoPadding}
            alt="Hochscrollen"
            className={cn(
              "h-[20px] transition-transform duration-250 transform-gpu",
              isOpen ? "rotate-180" : "",
            )}
          />
        </div>
        <div
          className={cn(
            "flex flex-col gap-2 text-[#4d4d4d]",
            !isOpen && "hidden",
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
